import api from '../utils/api'
import { API_ROOT } from '../constants'

// A fresh, single-use sign-in token for the community; request one per redirect
export const createCommunitySsoToken = (returnTo) =>
  api.post(`${API_ROOT}/v3/community/sso/token`, returnTo ? { returnTo } : {})
